if (!customElements.get('early-access-signup')) {
  class EarlyAccessSignup extends HTMLElement {
    static SUBSCRIBE_URL = 'https://a.klaviyo.com/client/subscriptions/';
    static API_REVISION = '2025-10-15';

    connectedCallback() {
      this.cacheElements();

      if (this.form) {
        this.form.addEventListener('submit', this.onSubmit.bind(this));
      }
    }

    cacheElements() {
      this.form = this.querySelector('form');
      this.input = this.querySelector('input[type="email"]');
      this.inputBar = this.querySelector('[data-signup-fields]');
      this.submitButton = this.form ? this.form.querySelector('button[type="submit"]') : null;
      this.errorEl = this.querySelector('[data-signup-error]');
      this.successEl = this.querySelector('[data-signup-success]');
    }

    async onSubmit(event) {
      event.preventDefault();

      const email = this.input ? this.input.value.trim() : '';
      if (!email) return;

      this.setBusy(true);
      this.toggleError(false);

      try {
        await this.subscribe(email);
        this.showSuccess();
      } catch (error) {
        console.error('Early Access: signup failed', error);
        this.toggleError(true);
      } finally {
        this.setBusy(false);
      }
    }

    async subscribe(email) {
      const companyId = (this.dataset.klaviyoCompanyId || '').trim();
      const listId = (this.dataset.klaviyoListId || '').trim();
      if (!companyId || !listId) throw new Error('Klaviyo public key or list ID is not configured');

      const response = await fetch(
        `${EarlyAccessSignup.SUBSCRIBE_URL}?company_id=${encodeURIComponent(companyId)}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/vnd.api+json',
            revision: EarlyAccessSignup.API_REVISION,
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: this.dataset.klaviyoSource || 'Early Access',
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email,
                      ...this.localeAttributes(),
                      subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                    },
                  },
                },
              },
              relationships: { list: { data: { type: 'list', id: listId } } },
            },
          }),
        }
      );

      if (!response.ok) throw new Error(`Klaviyo responded with ${response.status}`);
    }

    localeAttributes() {
      const language = (this.dataset.language || '').trim();
      const country = (this.dataset.country || '').trim().toUpperCase();
      if (!language) return {};

      const locale = language.includes('-') || !country ? language : `${language}-${country}`;
      const properties = { Taal: language };
      if (country) properties.Land = country;

      return { locale, properties };
    }

    showSuccess() {
      if (this.inputBar) this.inputBar.hidden = true;
      if (this.successEl) {
        this.successEl.hidden = false;
        this.successEl.focus();
      }
    }

    toggleError(isVisible) {
      if (this.errorEl) this.errorEl.hidden = !isVisible;
      if (this.input) this.input.toggleAttribute('aria-invalid', isVisible);
    }

    setBusy(isBusy) {
      if (this.submitButton) this.submitButton.disabled = isBusy;
      this.classList.toggle('is-busy', isBusy);
    }
  }

  customElements.define('early-access-signup', EarlyAccessSignup);
}
